<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Conectada"
        class="logo"
      />

      <div class="texts">
        <h2>Link expirado.</h2>
        <p>
          O link de primeiro acesso expirou e não pode mais ser utilizado.
          Solicite um novo link de ativação com o seu gestor ou através do
          e-mail cis.contato@sesisc.org.br.
        </p>
      </div>

      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
